// "Used Stratia before with Google or your email?" (#5154, founder pick A).
//
// A returning Google student who taps Apple and picks Hide My Email gets a
// new, empty account: nothing can match a relay address to anyone, so the
// student is the only one who knows. A new Facebook account may be the same.
// The first screen after such a new account carries one line, once, with a
// way to sign out and use the old way. Marked when the sign-in completes
// (authService.trackSignInResult), shown by <SecondAccountHint /> at the app
// root for that account only, then cleared.
import { track, EVENTS } from './analytics';

export const HINT_KEY = 'stratia_second_account_hint_v1';
const HINT_TTL_MS = 30 * 60 * 1000;
const listeners = new Set();

export function markSecondAccountHint(method, uid, now = Date.now()) {
    if (!uid) return;
    try { localStorage.setItem(HINT_KEY, JSON.stringify({ method, uid, t: now })); } catch { /* storage off */ }
    for (const fn of listeners) { try { fn(); } catch { /* never breaks sign-in */ } }
}

/** The hint waiting for this account, or null. */
export function hintFor(uid, now = Date.now()) {
    if (!uid) return null;
    try {
        const h = JSON.parse(localStorage.getItem(HINT_KEY) || 'null');
        if (h && h.uid === uid && typeof h.t === 'number' && now >= h.t && now - h.t < HINT_TTL_MS) return h;
    } catch { /* unreadable */ }
    return null;
}

export function clearSecondAccountHint() {
    try { localStorage.removeItem(HINT_KEY); } catch { /* storage off */ }
}

export function subscribeSecondAccountHint(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

export function trackHint(method, action) {
    try { track(EVENTS.SIGNIN_SECOND_ACCOUNT_HINT, { method, action }); } catch { /* never blocks */ }
}
